import React from 'react'
import { SketchPicker } from 'react-color'

class RGBPicker extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      color, //string: Hex color value of the color picker
      onChange, //function: (color, event) => void
      disableAlpha, //boolean: true if you want to hide the alpha slider
    } = this.props; 
    return(
      <SketchPicker 
        color={this.props.color}
        onChange={this.props.onChange}
        disableAlpha={this.props.disableAlpha}
      />
    ) 
  }
}

export default RGBPicker;


// WEBPACK FOOTER //
// ./source/client/components/common/inputs/rgbPicker.jsx